import { useEffect, useRef, useState } from 'react'
import { onNeedRefresh, onOfflineReady } from '../pwa/registerSW.js'

export function UpdatePromptToast() {
  const [offlineReady, setOfflineReady] = useState(false)
  const offlineShownRef = useRef(false)

  useEffect(() => {
    const unsubscribeRefresh = onNeedRefresh((nextUpdateSW) => {
      void nextUpdateSW(true)
    })
    const unsubscribeOffline = onOfflineReady(() => {
      if (offlineShownRef.current) return
      offlineShownRef.current = true
      setOfflineReady(true)
      window.setTimeout(() => setOfflineReady(false), 5200)
    })

    return () => {
      unsubscribeRefresh()
      unsubscribeOffline()
    }
  }, [])

  if (!offlineReady) return null

  return (
    <div className="pointer-events-none fixed right-4 bottom-4 z-50 flex max-w-[calc(100vw-2rem)] flex-col items-end gap-2">
      <div className="pointer-events-auto rounded-[var(--xr-radius-lg)] border border-[var(--xr-border-default)] bg-[var(--xr-bg-surface)] px-4 py-3 text-sm text-[var(--xr-text-primary)] shadow-[var(--xr-shadow-sm)]">
        离线可用
      </div>
    </div>
  )
}
